// extracted by mini-css-extract-plugin
export var cardLayout = "_1x-1";
export var paginationContainer = "_1x-0";